import { topliApi } from '@/shared/api/topli/TopliApi'
import { PromotionsRequestParams } from '../model/types'
import { useQuery } from '@tanstack/react-query'

export const currentPromotionByIdQueryKey = 'currentPromotionById'
export const promotionListsByPageQueryKey = 'promotionListsByPage'

export const fetchPromotionListByPage = async (
  sort: string | null,
  limit: number,
  offset: number,
  search: string,
) => {
  const requestParams: PromotionsRequestParams = {
    limit,
    offset,
    sort,
  }

  if (search.length) {
    requestParams.name__icontains = search
  }

  const response = await topliApi.promotions.list(requestParams)
  return response
}

export const fetchPromotionById = async (id?: number) => {
  if (!id) return

  const response = await topliApi.promotions.get(id)
  return response
}

export const usePromotionsByPage = (
  sort: string | null,
  limit: number,
  page: number,
  search: string,
) =>
  useQuery({
    queryKey: [promotionListsByPageQueryKey, sort, page, limit, search || ''],
    queryFn: () => fetchPromotionListByPage(sort, limit, page, search || ''),
  })

export const usePromotionById = (id?: number) =>
  useQuery({
    queryKey: [currentPromotionByIdQueryKey, id],
    queryFn: () => fetchPromotionById(id),
    enabled: !!id,
  })
